import { render, staticRenderFns } from "./UnplannedLeaveTable.vue?vue&type=template&id=57aa7716&scoped=true"
import script from "./UnplannedLeaveTable.vue?vue&type=script&lang=js"
export * from "./UnplannedLeaveTable.vue?vue&type=script&lang=js"
import style0 from "./UnplannedLeaveTable.vue?vue&type=style&index=0&id=57aa7716&prod&lang=scss&scoped=true"
import style1 from "./UnplannedLeaveTable.vue?vue&type=style&index=1&id=57aa7716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa7716",
  null
  
)

export default component.exports